import store from '@/store/store';
import { Route } from 'vue-router';

import { PublicSettings } from '../enums/publicSettings.enum';
import { tryParseInt } from './number';
import { prepareQuery } from './prepareQuery';

/**
 * Przygotowuje zapytanie dla paczek płatności
 *
 * @export
 * @param {Route} route
 * @returns {*}
 */
export function preparePaymentPackQuery(route: Route): any {
  const childProcedureSetting = store.state.setting.settings[PublicSettings.CHILD_PROCEDURE_ID];
  const procedureId = tryParseInt(childProcedureSetting?.value, route.params.procedureId.toString());
  return {
    ...prepareQuery(route),
    count: -1,
    order: route.query?.order?.includes('.') ? undefined : (route.query.order as string),
    procedureId,
    structureIds: store.state.auth.nodes?.map((node: any) => node.id)
  };
}
